const state = {
    address: {},
    tabHeight:62,
}
const mutations = {
    setEditAddress(state, data) {
        console.log(555);
        state.address = data
    },
    setTabHeight(state, data) {
        state.tabHeight = data
    }
}

const actions = {}
const getters = {
    addressGetters: (state) => state.address,
    tabHeightGetter: (state) => state.tabHeight,
}

export default {
    name: "common",
    state,
    mutations,
    getters,
    actions,
};
